module.exports = __webpack_public_path__ + "media/images/coke-8eac4f2cc0be964486a39a2cf05f5191.png";